import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'panchangam-theme';
const VALID_MODES = ['auto', 'light', 'dark'];
const MEDIA_QUERY = '(prefers-color-scheme: dark)';

export function useThemeMode() {
  const [mode, setModeState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return VALID_MODES.includes(stored) ? stored : 'auto';
    } catch { return 'auto'; }
  });

  const [osPrefersDark, setOsPrefersDark] = useState(() => {
    try { return window.matchMedia(MEDIA_QUERY).matches; }
    catch { return false; }
  });

  useEffect(() => {
    let mql;
    try { mql = window.matchMedia(MEDIA_QUERY); }
    catch { return; }
    const handler = (e) => setOsPrefersDark(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  const setMode = useCallback((next) => {
    const val = VALID_MODES.includes(next) ? next : 'auto';
    try { localStorage.setItem(STORAGE_KEY, val); } catch {}
    setModeState(val);
  }, []);

  const resolved = mode === 'dark' ? 'dark'
    : mode === 'light' ? 'light'
    : osPrefersDark ? 'dark' : 'light';

  return { mode, resolved, setMode };
}

export default useThemeMode;
